import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfSZ",
  "use": "BankOfSZ-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"BankOfSZ\">\r\n<defs>\r\n    <style>\r\n      #BankOfSZ .cls-1 {\r\n        fill: #629130;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfSZ_苏州银行logo\" class=\"cls-1\" d=\"M3491.34,482.056c-12.24,9.144-25.76,8.693-38.99-.4q13.86,18.333.92,38.174c6.49-4.336,12.84-6.534,19.08-6.534,6.32,0,12.51,2.254,18.57,6.826q-13.1-19.77.42-38.067h0Zm0.59-.52c18.89,6.453,18.8,32.723-.54,39.038-6.33,19.083-32.29,19.374-38.67.038A20.463,20.463,0,0,1,3438,500.924V500.89a20.192,20.192,0,0,1,14.23-19.4l0.08,0.112a20.224,20.224,0,0,1,19.62-14.6h0.04a20.773,20.773,0,0,1,19.96,14.536h0Zm0,0\" transform=\"translate(-3438 -467)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfSZ.svg
// module id = KR2D
// module chunks = 37